import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/key-account-groups/create',
    name: 'keyAccountGroupCreate',
    component: () =>
      import(
        '@/views/restricted/key-account-networks/key-account-group/KeyAccountGroupCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_GROUP_CREATE_PERMISSION'],
      menuSelected: 'key-account-networks'
    }
  },
  {
    path: '/key-account-groups/:groupId/edit',
    name: 'keyAccountGroupUpdate',
    component: () =>
      import(
        '@/views/restricted/key-account-networks/key-account-group/KeyAccountGroupUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_GROUP_UPDATE_PERMISSION'],
      menuSelected: 'key-account-networks'
    }
  },
  {
    path: '/key-account-groups/:groupId',
    name: 'keyAccountGroupDetail',
    component: () =>
      import(
        '@/views/restricted/key-account-networks/key-account-group/KeyAccountGroupDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_KEY_ACCOUNT_GROUP_READ_PERMISSION'],
      menuSelected: 'key-account-networks'
    }
  }
]
